export const getFullUrl = (headers: Headers): string | undefined => {
  return headers.get('x-full-url') ?? undefined;
};

export const isSafeCallbackUrl = (url: string): boolean => {
  if (!url.startsWith('/')) {
    return false;
  }

  try {
    return new URL(url, 'http://localhost').origin === 'http://localhost';
  } catch {
    return false;
  }
};
